import {
    MtMailSettings,
    MtMailTemplate,
} from "server/models"

export interface MailMessage {
    from: string
    to: string
    subject: string
    html: string
}

export type MailSettingsValidation = { [key in keyof MtMailSettings]?: string}
export type MailTemplateValidation = { [key in keyof MtMailTemplate]?: string}

export interface MailState {
    settingList: readonly MtMailSettings[]
    settingEdit: MtMailSettings
    reloadSettingList: boolean

    templateList: readonly MtMailTemplate[]
    templateEdit: MtMailTemplate
    reloadTemplateList: boolean
    reloadTemplateEdit: boolean
}

export const MAIL_SETTING_LIST = "MAIL_SETTING_LIST"
export const MAIL_SETTING_EDIT = "MAIL_SETTING_EDIT"
export const MAIL_SETTING_RELOAD_LIST = "MAIL_SETTING_RELOAD_LIST"

export const MAIL_TEMPLATE_LIST = "MAIL_TEMPLATE_LIST"
export const MAIL_TEMPLATE_EDIT = "MAIL_TEMPLATE_EDIT"
export const MAIL_TEMPLATE_RELOAD_LIST = "MAIL_TEMPLATE_RELOAD_LIST"
export const MAIL_TEMPLATE_RELOAD_EDIT = "MAIL_TEMPLATE_RELOAD_EDIT"
